import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Second from '@/components/second'
import Second2 from '@/components/second2'
import Third from '@/components/third'
import Fourth from '@/components/fourth'
import Fifth from '@/components/fifth'
import Sixth from '@/components/sixth'
import Seventh from '@/components/seventh'
import Select from '@/components/select'
import Howtoplay from '@/components/howtoplay'
import Rank from '@/components/rank'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'HelloWorld',
		component: HelloWorld
	}, {
		path: '/second',
		name: 'second',
		component: Second
	}, {
        path: '/second2',
        name: 'second2',
        component: Second2
    }, {
		path: '/third',
		name: 'third',
		component: Third
	}, {
		path: '/fourth',
		name: 'fourth',
		component: Fourth
	}, {
		path: '/fifth',
		name: 'fifth',
		component: Fifth
	}, {
		path: '/sixth',
		name: 'sixth',
		component: Sixth
	},{
        path: '/seventh',
        name: 'seventh',
        component: Seventh
    },{
        path: '/select',
        name: 'select',
        component: Select
    },{
        path: '/howtoplay',
        name: 'howtoplay',
        component: Howtoplay
    },{
        path: '/rank',
        name: 'rank',
        component: Rank
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js